export default __webpack_public_path__ + "static/media/Roboto-BoldItalic.87793839.woff";